import { ColorEnum } from '@/constants/color'
import OrderCompletionIndicator from '@/features/orders/components/OrderCompletionIndicator'
import OrderListItem from '@/features/orders/components/OrderListItem'
import { useOrderDetailNavigation } from '@/features/orders/hooks/useOrderDetailNavigation'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { FC, memo } from 'react'
import invariant from 'tiny-invariant'

interface ArchivedOrderListItemProps {
    uuid: string
    selected?: boolean
}

const ArchivedOrderListItem: FC<ArchivedOrderListItemProps> = ({ uuid, selected }) => {
    const order = useAppSelector(ordersSelectors.orderByUuid(uuid))

    const navigate = useOrderDetailNavigation()

    invariant(order, 'Order must be provided')

    return (
        <OrderListItem
            order={order}
            RightEndComponent={
                <OrderCompletionIndicator
                    state={order.state}
                    acceptedDeliveryTime={order.acceptedDeliveryTime}
                    deliveredAt={order.deliveredAt}
                />
            }
            onPress={() => navigate(uuid)}
            style={selected && { backgroundColor: ColorEnum.YELLOW_200 }}
        />
    )
}

export default memo(ArchivedOrderListItem)
